import React from 'react'
import styled, { css } from 'styled-components'
import { responsive } from '../../utils/responsive'

const shadows = {
  sm: (t) => t.shadow.sm,
  md: (t) => t.shadow.md,
  lg: (t) => t.shadow.lg
}

const Root = styled.div`
  display: block;
  width: ${(p) => (p.$full ? '100%' : 'auto')};
  ${(p) => responsive('padding', p.$p || p.theme.layout?.box?.padding || p.theme.space.md, p.theme)}
  ${(p) => css`border-radius: ${p.$radius || p.theme.layout?.box?.radius || p.theme.radii.md};`}
  ${(p) => css`background: ${p.$bg || p.theme.colors.surface};`}
  ${(p) => p.$bordered ? css`border: 1px solid ${p.theme.colors.border};` : css`border: none;`}
  ${(p) => css`box-shadow: ${shadows[p.$shadow || p.theme.layout?.box?.shadow || 'sm'](p.theme)};`}
`

export function Box({ children, p, radius, bg, bordered = false, shadow, fullWidth = false }) {
  return (
    <Root $p={p} $radius={radius} $bg={bg} $bordered={bordered} $shadow={shadow} $full={fullWidth}>
      {children}
    </Root>
  )
}
